import React from "react";

const LoadingScreen = ({ message = "Loading..." }) => {
  return (
    <div className="flex justify-center items-center min-h-screen bg-white">
      <div className="flex flex-col items-center space-y-6">
        {/* Simple spinner */}
        <div className="w-8 h-8 border-2 border-gray-200 border-t-gray-900 rounded-full animate-spin"></div>

        {/* Message */}
        <p className="text-sm text-gray-600 font-light">{message}</p>
      </div>
    </div>
  );
};

export default LoadingScreen;
